module.exports = __webpack_public_path__ + "img/image-8.c694ff5d.jpeg";